import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CanPaymentDetailsPage from "../can-payment-details-jobs";
import ReportTimeDetails from "../can-report-time-details";
import { downloadTimeSheetCSV, downloadPaymentCSV, downloadJobCSV } from "../export-csv/download-reports-csv";
import Spinner from "../../../../common/spinner";
import { useSelector } from "react-redux";

const ReportsTabs = () => {
  const navigate = useNavigate();
  const { role_type } = useSelector((state) => state.menu);
  const [activeTab, setActiveTab] = useState("report-payment-history"); // State for active tab
  const [isDownloadTimeCSV, setIsDownloadTimeCSV] = useState(false);
  const [isDownloadPaymentCSV, setIsDownloadPaymentCSV] = useState(false);
  const [isDownloadJobCSV, setIsDownloadJobCSV] = useState(false);
  const [empPaymentInfo, setEmpPaymentInfo] = useState([]);
  const [empTimeLogsInfo, setEmpTimeLogsInfo] = useState([]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleDownloadTimeCSV = (data) => {
    downloadTimeSheetCSV(data, role_type);
  };

  const handleDownloadPaymentCSV = (data) => {
    downloadPaymentCSV(data, role_type);
  };

  const handleDownloadJobCSV = (data) => {
    downloadJobCSV(data, role_type);
  };

  return (
    <>
      <div className="twm-tabs-style-2">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "report-payment-history" ? "active" : ""
              }`}
              data-bs-toggle="tab"
              data-bs-target="#report-payment-history"
              type="button"
              onClick={() => handleTabChange("report-payment-history")}
            >
              <i className="fas fa-history" /> Payment History
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "report-jobs" ? "active" : ""
              }`}
              data-bs-toggle="tab"
              data-bs-target="#report-jobs"
              type="button"
              onClick={() => handleTabChange("report-jobs")}
            >
              <i className="fa fa-briefcase" /> Job
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${
                activeTab === "report-time" ? "active" : ""
              }`}
              data-bs-toggle="tab"
              data-bs-target="#report-time"
              type="button"
              onClick={() => handleTabChange("report-time")}
            >
              <i className="fa fa-clock" /> Time
            </button>
          </li>
        </ul>
        <div className="tab-content">
          {(activeTab === "report-payment-history" ||
            activeTab === "report-jobs") && (
            <div
              className={`tab-pane fade show active`}
              id={activeTab}
              role="tabpanel"
            >
              <div className="panel-heading wt-panel-heading p-a20 d-flex justify-content-between align-items-center">
                <h3 className="wt-title">
                  {activeTab === "report-payment-history"
                    ? "Payment History"
                    : "Job"}
                </h3>
                {
                  empPaymentInfo?.length > 0 && 
                  <button
                  type="button"
                  className="site-button"
                  role="button"
                  onClick={() =>
                    activeTab === "report-payment-history"
                      ? setIsDownloadPaymentCSV(true)
                      : setIsDownloadJobCSV(true)
                  }
                >
                  {!isDownloadPaymentCSV && !isDownloadJobCSV && (
                    <i class="fas fa-download"></i>
                  )}
                  {activeTab === "report-payment-history" ? (
                    isDownloadPaymentCSV ? (
                      <Spinner />
                    ) : (
                      "Export Payment History"
                    )
                  ) : isDownloadJobCSV ? (
                    <Spinner />
                  ) : (
                    "Export Job History"
                  )}
                </button>

                }
                
              </div>
              <CanPaymentDetailsPage
                activeTab={activeTab}
                isDownloadPaymentCSV={isDownloadPaymentCSV}
                isDownloadJobCSV={isDownloadJobCSV}
                empPaymentInfo={empPaymentInfo}
                setEmpPaymentInfo={setEmpPaymentInfo}
                setIsDownloadJobCSV={setIsDownloadJobCSV}
                setIsDownloadPaymentCSV={setIsDownloadPaymentCSV}
                handleDownloadPaymentCSV={handleDownloadPaymentCSV}
                handleDownloadJobCSV={handleDownloadJobCSV}
              />
            </div>
          )}
          {activeTab === "report-time" && (
            <div
              className="tab-pane fade show active"
              id="report-time"
              role="tabpanel"
            >
              <div className="panel-heading wt-panel-heading p-a20 d-flex justify-content-between align-items-center">
                <h3 className="wt-title">Time</h3>
                {
                  empTimeLogsInfo?.length > 0 && 
                  <button
                    type="button"
                    className="site-button"
                    role="button"
                    onClick={() => setIsDownloadTimeCSV(true)}
                  >
                    {isDownloadTimeCSV ? (
                      <Spinner />
                    ) : (
                      <>
                        <i class="fas fa-download"></i>
                        Export Time Sheet
                      </>
                    )}
                  </button>
                }
                
              </div>
              <ReportTimeDetails
                activeTab={activeTab}
                isDownloadTimeCSV={isDownloadTimeCSV}
                empTimeLogsInfo={empTimeLogsInfo}
                setEmpTimeLogsInfo={setEmpTimeLogsInfo}
                setIsDownloadTimeCSV={setIsDownloadTimeCSV}
                handleDownloadTimeCSV={handleDownloadTimeCSV}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReportsTabs;
